import React, { useEffect, useState } from "react";
import MetaTags from "react-meta-tags";
import {
  Button,
  Checkbox,
  Col,
  Divider,
  Input,
  Modal,
  Row,
  Space,
  Tooltip,
  Typography,
  DatePicker,
  Switch,
  AutoComplete,
  Select,
  Radio,
  Upload,
  Image,
} from "antd";
import qrCodeLogo from "../../assets/images/barcode-placeholder.svg";
import { ToastContainer } from "react-toastify";
import {
  SettingOutlined,
  PlusOutlined,
  CloseCircleOutlined,
  PlusCircleFilled,
  DownOutlined,
  ArrowLeftOutlined,
  ArrowDownOutlined,
  ArrowUpOutlined,
  InfoCircleOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import { PiBarcodeBold } from "react-icons/pi";
import { isEmpty } from "lodash";
import { Prompt } from "react-router-dom";
import moment from "moment";
import { BiCalendar, BiQrScan } from "react-icons/bi";
import axios from "axios";
import CreateItems from "../Items/items";
import useBeforeUnload from "../../components/Prompting";
import { createItemTableData } from "./data";
import "./index.css";

const CreatePurchase = () => {
  //purchase State values

  const [columnSettings, setColumnSettings] = useState(false);
  const [notesOpen, setNotesOpen] = useState(false);
  const [termsOpen, setTermsOpen] = useState(false);
  const [additionalChargesOpen, setAdditionalChargesOpen] = useState(false);
  const [discountOpen, setDiscountOpen] = useState(false);
  const [autoRoundOff, setAutoRoundOff] = useState(false);
  // const [signatureModal, setSignatureModal] = useState(false);
  const [fullyPaid, setFullyPaid] = useState("");
  const [autoRoundOffMethod, setAutoRoundOffMethod] = useState([]);
  const [applyTcs, setApplyTcs] = useState("");
  const [applyTds, setApplyTds] = useState("");
  const [tcsList, setTcsList] = useState([]);
  const [tcsAmount, setTcsAmount] = useState("");
  const [tdsList, setTdsList] = useState([]);
  const [amountPaidList, setAmountPaidList] = useState([]);

  const [purchaseData, setPurchaseData] = useState({
    price: true,
    quantity: true,
    travel: true,
    batch: true,
    expiryDate: true,
    mfgDate: false,
  });

  const [totalSectionData, setTotalSectionData] = useState({
    chargesData: "",
    additionalCharges: "",
    discountPercent: "",
    discountAmount: "",
    autoRoundOffValue: "",
    amountPaid: "",
    totalAmount: "",
    tcsTaxName: "",
    tcsSectionName: "",
    tcsRatePercent: "",
    tdsTaxName: "",
    tdsSectionName: "",
    tdsRatePercent: "",
  });
  const [additionalOptions, setAdditionalOptions] = useState([]);
  const [discount, setDiscount] = useState([]);

  const handlePurchaseChange = (e) => {
    setTotalSectionData({
      ...totalSectionData,
      [e.target.name]: e.target.value,
    });
  };

  const handleDiscountChange = (e) => {
    const listData = totalSectionData;
    listData.discountPercent = parseInt(e.target.value * 100);

    setTotalSectionData(listData);
  };

  //Item create modal
  const [itemModal, setItemModal] = useState(false);
  const [createItemModal, setCreateItemModal] = useState(false);
  const [scanQrModal, setScanQrModal] = useState(false);
  const [itemCategory, setItemCategory] = useState([]);
  // const [expandable, setExpandable] = useState(false);
  const [quantityShow, setQuantityShow] = useState(false);
  const [quantityCount, setQuantityCount] = useState(false);
  const [quantityCountValue, setQuantityCountValue] = useState(0);
  const [pageRender, setPageRender] = useState(false);
  const [purchasePriceModal, setPurchasePriceModal] = useState(false);
  const [purchaseColumn, setPurchaseColumn] = useState(false);
  const [asOfDate, setAsOfDate] = useState("");
  const [batchingModal, setBatchingModal] = useState(false);

  const handleClose = (data) => {
    setCreateItemModal(data);
  };

  const mockItemVal = (str, repeat = 1) => ({
    value: str.repeat(repeat),
  });

  //Serialisation
  const [serialOpenStock, setSerialOpenStock] = useState("");
  const [serialData, setSerialData] = useState([
    {
      serialNo: "",
    },
  ]);

  const addSerialData = () => {
    setSerialData([
      ...serialData,
      {
        serialNo: "",
      },
    ]);
    // setSerialDataAdd(true);
    setPageRender(!pageRender);
  };

  const removeSerialData = (index) => {
    const array = serialData;
    if (index !== 0) {
      if (index > -1) {
        array.splice(index, 1);
        setSerialOpenStock(array.length);
        // if (array.length === 1) {
        //   setSerialData([
        //     ...serialData,
        //     {
        //       serialNo: "",
        //     },
        //   ]);
        // }
      }
    }
    setPageRender(!pageRender);
  };

  const handleSerialDataChange = (e, name, index) => {
    var fieldList = serialData;
    if (name === "serialNo") {
      fieldList[index][name] = e.target.value;
      setSerialData(fieldList);

      // if (fieldList.length > 0 && !isEmpty(fieldList[0].serialNo)) {
      setSerialOpenStock(fieldList.length);
      // }
      setPageRender(!pageRender);
    }
  };

  //Search parties
  const [itemOptions, setItemOptions] = useState([]);
  const getItemPanelValue = (searchText) =>
    !searchText ? [] : [mockItemVal(searchText)];
  const onItemsSelect = (data) => {
    console.log("onSelect", data);
  };

  //tds & tcs
  // const [itemsData, setItemsData] = useState([]);
  // const [tdsItemsData, setTdsItemsData] = useState([]);
  const [tdsRateModal, setTdsRateModal] = useState(false);
  const [tcsRateModal, setTcsRateModal] = useState(false);
  // const [name, setName] = useState("");
  // const inputRef = useRef(null);

  const addItem = () => {
    setTcsRateModal(true);
  };

  const addTdsItem = () => {
    setTdsRateModal(true);
  };
  //settings States data
  const [invoiceShow, setInvoiceShow] = useState(false);
  const [settingsFieldModal, setSettingsFieldModal] = useState(false);

  const [purchaseSettings, setPurchaseSettings] = useState({
    prefix: "Prefix",
    seqNo: "",
  });

  const handleChange = (e) => {
    setPurchaseSettings({
      ...purchaseSettings,
      [e.target.name]: e.target.value,
    });
  };

  const handleOk = () => {
    setSettingsFieldModal(false);
  };
  const handleCancel = () => {
    setSettingsFieldModal(false);
  };

  //create party modal states

  const [partyModalData, setPartyModalData] = useState({
    mobile: "",
    name: "",
    cityName: "",
    gstIn: "",
    billingAddress: "",
  });

  const handleModalChange = (e) => {
    setPartyModalData({
      ...partyModalData,
      [e.target.name]: e.target.value,
    });
  };
  const [sameAs, setSameAs] = useState("");
  const [stateData, setStateData] = useState([]);
  const [pincode, setPincode] = useState("");
  const [partyModal, setPartyModal] = useState(false);
  const [createPartyModal, setCreatePartyModal] = useState(false);
  const [addAddressShow, setAddAddressShow] = useState(false);
  const [addGstShow, setAddGstShow] = useState(false);

  const mockVal = (str, repeat = 1) => ({
    value: str.repeat(repeat),
  });

  //Search purchase
  const [options, setOptions] = useState([]);
  const getPanelValue = (searchText) =>
    !searchText ? [] : [mockVal(searchText)];
  const onSelect = (data) => {
    console.log("onSelect", data);
  };
  console.log(purchaseData, "purchaseData");

  //Image upload
  const getBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });

  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const [fileList, setFileList] = useState([]);

  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewImage(file.url || file.preview);
    setPreviewOpen(true);
  };
  const handleImageChange = ({ fileList: newFileList }) =>
    setFileList(newFileList);
  const uploadButton = (
    <button
      style={{
        border: 0,
        background: "none",
      }}
      type="button"
    >
      <PlusOutlined />
      <div
        style={{
          marginTop: 8,
        }}
      >
        Add Signature
      </div>
    </button>
  );

  //Initial load

  useEffect(() => {
    setAdditionalOptions({
      value: "No Tax Applicable",
      label: "No Tax Applicable",
    });
    setDiscount({
      value: "Display After Tax",
      label: "Display After Tax",
    });
    setAutoRoundOffMethod({
      value: "Add",
      label: "+ Add",
    });
    setAmountPaidList({
      value: "Cash",
      label: "Cash",
    });
  }, []);
  useBeforeUnload({
    when: !isEmpty(totalSectionData),
    message: "Are you sure you want to leave?",
  });
  return (
    <React.Fragment>
      <div className="">
        <MetaTags>
          <title>Add Debit Note | Mbook</title>
        </MetaTags>
      </div>

      {/* <Prompt
        when={isFormIncomplete}
        message="Are you sure you want to leave?"
      /> */}

      <Row
        // onMouseEnter={() => setMouseHover(true)}
        // onMouseLeave={() => setMouseHover(false)}
        className="border-solid rounded-sm bg-[#ffffff]"
      >
        <Col span={24}>
          <div className="font-poppins flex justify-between pl-[20px] pr-[20px] mt-4">
            <div className="flex">
              <ArrowLeftOutlined
                // onClick={() => setPageRouting(true)}
                className="font-bold text-[18px]"
              />
              <h1
                style={{
                  fontFamily: "Poppins",
                }}
                className="text-[20px] ml-2 mt-1 font-semibold"
              >
                Create Debit Note
              </h1>
            </div>
            <div className="flex">
              <Tooltip
                title="Introducing custom fields -> Now you can add custom party fields like Drug licence number, ID, etc.,"
                placement="bottom"
                rootClassName="text-[10px]"
              >
                <div
                  style={{
                    fontFamily: "Poppins",
                  }}
                  onClick={() => setSettingsFieldModal(true)}
                  className="border rounded-md mr-3 pt-1.5 pb-1.5 pr-6 pl-6 cursor-pointer"
                >
                  Settings <SettingOutlined />
                </div>
              </Tooltip>
              <div
                style={{
                  fontFamily: "Poppins",
                }}
                className="border rounded-md hover:bg-[#efefef] ml-3 pl-8 pr-8 p-1 cursor-pointer"
              >
                Save & New
              </div>
              <div
                style={{
                  fontFamily: "Poppins",
                }}
                className="border bg-[#1a276dd4] hover:bg-[#7163c1] text-[#ffffff] rounded-md ml-3 pl-8 pr-8 p-1.5 cursor-pointer"
              >
                Save
              </div>
            </div>
          </div>
        </Col>
        <div className="add-purchase-main pr-4 pl-5 pt-3 mt-4">
          <Col span={24} className="add-purchase-card mb-4">
            {/* File form section */}
            <Row className="border border-t-0 border-r-0 border-b-1">
              <Col
                span={15}
                className="border border-r-1 border-l-0 border-b-0 border-t-0"
              >
                <div className="border p-1.5 border-l-0 border-t-0 border-r-0 border-b-1">
                  <h1 className="ml-3 purchase-label text-[16px] font-medium">
                    Bill From
                  </h1>
                </div>
                <Row className="p-6">
                  {partyModal === true ? (
                    <Col span={16} className="purchase-party-card">
                      <Row className="flex flex-col mb-1">
                        <Col span={24} className="flex justify-end pt-2 pr-2">
                          <CloseCircleOutlined
                            onClick={() => setPartyModal(false)}
                          />
                        </Col>
                        <Col span={24} className="pr-3 pl-3 pt-2 pb-2">
                          <AutoComplete
                            options={options}
                            className="mt-2 border border-none rounded-sm mb-2 w-[100%] mr-2"
                            onSelect={onSelect}
                            onSearch={(text) => setOptions(getPanelValue(text))}
                          >
                            <Input.Search
                              size="large"
                              placeholder="Search party by name or phone number"
                              style={
                                {
                                  // height: "40px",
                                }
                              }
                              // enterButton
                            />
                          </AutoComplete>
                        </Col>
                        <Col span={24} className="">
                          <div>
                            <div className="purchase-label flex border p-2 border-b-1.5 border-x-0 border-t-0 justify-between">
                              <h1 className="ml-2 text-[14px]">Party Name</h1>
                              <p className="mr-2 text-[14px]">Balance</p>
                            </div>
                            <div className="purchase-label bg-[#e9ecf1] flex border p-2 border-b-1.5 border-x-0 border-t-0 justify-between">
                              <h1 className="ml-2 font-semibold text-[14px]">
                                Cash Sale
                              </h1>
                              <p className="mr-2 font-semibold text-[14px]">
                                0.0
                              </p>
                            </div>
                            <div className="purchase-label hover:bg-[#e9ecf1] flex border p-2 border-b-1.5 border-x-0 border-t-0 justify-between">
                              <h1 className="ml-2 text-[14px]">Faizal</h1>
                              <p className="mr-2 flex text-[14px]">
                                ₹ -600
                                <ArrowDownOutlined className="ml-1 text-[18px] text-[red]" />
                              </p>
                            </div>
                            <div className="purchase-label hover:bg-[#e9ecf1] flex border p-2 border-b-1.5 border-x-0 border-t-0 justify-between">
                              <h1 className="ml-2 text-[14px]">Salmaan</h1>
                              <p className="mr-2 flex text-[14px]">
                                ₹ 300{" "}
                                <ArrowUpOutlined className="ml-1 text-[18px] text-[green]" />
                              </p>
                            </div>
                          </div>
                        </Col>
                        <Col span={24} className="p-3">
                          <div
                            onClick={() => setCreatePartyModal(true)}
                            className="text-center text-[#488dff] cursor-pointer border border-dashed border-1 border-blue-400 pt-2 pb-2 pl-10 pr-10"
                          >
                            <PlusOutlined /> Create Party
                          </div>
                        </Col>
                      </Row>
                    </Col>
                  ) : (
                    <div className="w-[50%]">
                      <div
                        onClick={() => setPartyModal(true)}
                        className="text-center text-[#488dff] cursor-pointer border border-dashed border-2 border-blue-400 p-12"
                      >
                        <PlusOutlined /> Add Party
                      </div>
                    </div>
                  )}
                </Row>
              </Col>
              <Col span={9}>
                <Row className="pl-3 pt-3">
                  <Col span={8} className="pr-3">
                    <Typography className="input-label mb-1 text-[10px]">
                      Purchase Inv No:
                    </Typography>
                    <Input
                      name="purchaseInvoice"
                      //   placeholder="Enter field name"
                      className="rounded-md border-none hover:bg-[#e9ecf1] focus:bg-[#e9ecf1] h-[30px] bg-[#e9ecf1]"
                      //   onChange={(e) =>
                      //     handleCustomFieldsChange(e, "fieldName", index)
                      //   }
                    />
                  </Col>
                  <Col span={8} className="pr-3">
                    <Typography className="input-label mb-1 text-[10px]">
                      Purchase Inv Date:
                    </Typography>
                    <DatePicker
                      name="invoiceDate"
                      //   placeholder="Enter field name"
                      className="rounded-md border-none hover:bg-[#e9ecf1] focus:bg-[#e9ecf1] h-[30px] bg-[#e9ecf1]"
                      //   onChange={(e) =>
                      //     handleCustomFieldsChange(e, "fieldName", index)
                      //   }
                      suffixIcon={
                        <BiCalendar size={18} className="text-[#9e9e9e]" />
                      }
                    />
                  </Col>
                </Row>
              </Col>
            </Row>

            {/* Item table section */}
            <Row className="border border-x-0 border-y-0 p-5">
              <Col span={24} className="p-2 add-create-item-table">
                <table className="table-purchase-serial table-responsive">
                  <thead>
                    <tr>
                      <th className="table-head uppercase text-[12px] font-medium">
                        No
                      </th>
                      <th className="table-head uppercase text-[12px] font-medium">
                        Items/ Services
                      </th>
                      <th className="table-head uppercase text-[12px] font-medium">
                        HSN/ SAC
                      </th>
                      {purchaseData.travel === true ? (
                        <th className="table-head uppercase text-[12px] font-medium">
                          Travel
                        </th>
                      ) : (
                        ""
                      )}
                      {purchaseData.batch === true ? (
                        <th className="table-head uppercase text-[12px] font-medium">
                          Batch no.
                        </th>
                      ) : (
                        ""
                      )}
                      {purchaseData.expiryDate === true ? (
                        <th className="table-head uppercase text-[12px] font-medium">
                          Exp. Date
                        </th>
                      ) : (
                        ""
                      )}
                      {purchaseData.mfgDate === true ? (
                        <th className="table-head uppercase text-[12px] font-medium">
                          Mfg Date
                        </th>
                      ) : (
                        ""
                      )}
                      {purchaseData.quantity === true ? (
                        <th className="table-head uppercase text-[12px] font-medium">
                          Qty
                        </th>
                      ) : (
                        ""
                      )}
                      {purchaseData.price === true ? (
                        <th className="table-head uppercase text-[12px] font-medium">
                          Price/Item (₹)
                        </th>
                      ) : (
                        ""
                      )}

                      <th className="table-head uppercase text-[12px] font-medium">
                        Discount
                      </th>
                      <th className="table-head uppercase text-[12px] font-medium">
                        Tax
                      </th>
                      <th className="table-head uppercase text-[12px] font-medium">
                        Amount (₹)
                      </th>
                      <th className="table-head uppercase text-[12px] font-medium">
                        <div
                          className="cursor-pointer"
                          onClick={() => setColumnSettings(true)}
                        >
                          <PlusCircleFilled className="text-[30px] text-[#8b8787]" />
                        </div>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {/* {purchaseItemColumns.map((data, index) => {
                          return (
                            <tr key={index} className="table-row">
                              <td className="table-head">{data.value}</td>
                              <td className="table-head">
                                <DeleteOutlined
                                  //   onClick={() => removeCustomFields(index)}
                                  type="primary"
                                  className="ml-3 border rounded-md p-2 text-[red] cursor-pointer"
                                  size={"large"}
                                />
                              </td>
                            </tr>
                          );
                        })} */}
                  </tbody>
                </table>
              </Col>
              <Col span={24} className="mt-2">
                <Row className="px-2">
                  <Col span={18}>
                    <div
                      onClick={() => {
                        setItemModal(true);
                        setScanQrModal(false);
                      }}
                      className="text-center text-[#488dff] cursor-pointer border border-dashed border-1 border-blue-400 pt-5 pb-5 pl-10 pr-10"
                    >
                      <PlusOutlined /> Add Item
                    </div>
                  </Col>
                  <Col span={6} className="pl-4">
                    <div
                      onClick={() => {
                        setItemModal(true);
                        setScanQrModal(true);
                      }}
                      className="cursor-pointer flex border border-1 pt-3 pb-3 pl-5 pr-5"
                    >
                      <PiBarcodeBold size={40} className="mr-2" />
                      <h1 className="purchase-label text-[18px] mt-2 font-medium">
                        Scan Barcode
                      </h1>
                    </div>
                  </Col>
                </Row>
              </Col>
            </Row>

            {/* Total section */}
            <Row className="w-[100%] bg-gray-50 p-2 border border-x-0 pl-5 pr-5 mt-3">
              <Col span={17} className="flex justify-end">
                <div className="flex">
                  <h1 className="text-[14px] pr-2 text-end purchase-label font-semibold">
                    SUB-Total
                  </h1>
                  <Divider
                    // className="w-[110%] ml-[-24px]"
                    type="vertical"
                    className="total-divider"
                  />
                </div>
              </Col>
              <Col span={2} className="">
                <div className="flex">
                  <h1 className="text-[14px] pr-4 text-end purchase-label font-semibold">
                    ₹ 0.145
                  </h1>
                  <Divider
                    // className="w-[110%] ml-[-24px]"
                    type="vertical"
                    className="total-divider"
                  />
                </div>
              </Col>
              <Col span={2}>
                <div className="flex">
                  <h1 className="text-[14px] pr-2 purchase-label font-semibold">
                    ₹ 2.34
                  </h1>
                  <Divider
                    // className="w-[110%] ml-[-24px]"
                    type="vertical"
                    className="total-divider"
                  />
                </div>
              </Col>
              <Col span={3}>
                <h1 className="text-[14px] pr-2 purchase-label font-semibold">
                  ₹ 15.34
                </h1>
              </Col>
            </Row>

            {/* Add notes, total section */}
            <Row className="border border-x-0 border-t-0 border-b-0">
              <Col
                span={12}
                className="border border-r-1 border-l-0 border-y-0"
              >
                <div className="p-6 border border-x-0 border-b-1 border-t-0">
                  {notesOpen === true ? (
                    <div className="mt-3">
                      <Typography className="input-label mb-1 flex justify-between">
                        Notes
                        <CloseCircleOutlined
                          onClick={() => setNotesOpen(false)}
                        />
                      </Typography>
                      <Input.TextArea
                        placeholder="Enter your notes"
                        className="p-2 h-[35px] bg-[#e9ecf1] border-none focus:bg-[#e9ecf1] hover:bg-[#e9ecf1]"
                      />
                    </div>
                  ) : (
                    <div
                      onClick={() => setNotesOpen(true)}
                      className="mb-3 text-[#488dff] cursor-pointer"
                    >
                      <PlusOutlined /> Add Notes
                    </div>
                  )}
                  {termsOpen === true ? (
                    <div className="mt-3">
                      <Typography className="input-label mb-1 flex justify-between">
                        Terms and Conditions{" "}
                        <CloseCircleOutlined
                          onClick={() => setTermsOpen(false)}
                        />
                      </Typography>
                      <Input.TextArea
                        placeholder="Enter your terms & conditions"
                        className="p-3 h-[35px] bg-[#e9ecf1] border-none focus:bg-[#e9ecf1] hover:bg-[#e9ecf1]"
                      />
                    </div>
                  ) : (
                    <div
                      onClick={() => setTermsOpen(true)}
                      className="mt-3 text-[#488dff] cursor-pointer"
                    >
                      <PlusOutlined /> Add Terms and Conditions
                    </div>
                  )}
                </div>
              </Col>
              <Col
                span={12}
                className="border border-r-1 border-l-0 border-y-0"
              >
                {/* Total , after gst section */}
                {discount === "Display Before Tax" ? (
                  <div className="p-6 border border-x-0 border-b-1 border-t-0">
                    {discountOpen === true ? (
                      <div className="w-[100%] flex mt-4">
                        <Select
                          value={discount}
                          onChange={(e) => setDiscount(e)}
                          style={{
                            width: "50%",
                            height: 35,
                          }}
                          defaultValue={"Display After Tax"}
                          options={[
                            {
                              value: "Display Before Tax",
                              label: "Display Before Tax",
                            },
                            {
                              value: "Display After Tax",
                              label: "Display After Tax",
                            },
                          ]}
                        />
                        <Tooltip
                          title="Invoice discount will be split among items in the ratio of taxable amount"
                          placement="top"
                        >
                          <InfoCircleOutlined className="ml-3 16px mr-3" />
                        </Tooltip>
                        <Input
                          name="discountPercent"
                          value={totalSectionData.discountPercent}
                          onChange={(e) => handlePurchaseChange(e)}
                          type="text"
                          prefix={"% "}
                          placeholder="0"
                          className=" w-[40%] focus:bg-[#e9ecf1] hover:bg-[#e9ecf1] bg-[#e9ecf1] mr-2 h-[25px]"
                        />
                        <p className="pr-2 pl-2 text-[16px] pt-2">{" / "}</p>
                        <Input
                          name="discountAmount"
                          value={totalSectionData.discountAmount}
                          onChange={(e) => handleDiscountChange(e)}
                          type="text"
                          prefix={"₹ "}
                          placeholder="0"
                          className="w-[40%] focus:bg-[#e9ecf1] hover:bg-[#e9ecf1] bg-[#e9ecf1] mr-2 h-[25px]"
                        />
                        <CloseCircleOutlined
                          className="w-[15%] pl-5"
                          onClick={() => setDiscountOpen(false)}
                        />
                      </div>
                    ) : (
                      <div className="flex justify-between mb-3 text-[#488dff] cursor-pointer">
                        <div onClick={() => setDiscountOpen(true)}>
                          <PlusOutlined /> Add Discount
                        </div>
                        <div>
                          <h1>-₹. 0</h1>
                        </div>
                      </div>
                    )}

                    {additionalChargesOpen === true ? (
                      <div className="w-[100%] flex mt-3">
                        <Input
                          name="chargesData"
                          value={totalSectionData.chargesData}
                          placeholder="Enter charge(eg: transport charge)"
                          onChange={(e) => handlePurchaseChange(e)}
                          className="w-[70%] pr-2 h-[40px] bg-[#e9ecf1] focus:bg-[#e9ecf1] hover:bg-[#e9ecf1]"
                        />
                        <Input
                          name="additionalCharges"
                          value={totalSectionData.additionalCharges}
                          onChange={(e) => handlePurchaseChange(e)}
                          addonAfter={
                            <Select
                              value={additionalOptions}
                              onChange={(e) => setAdditionalOptions(e)}
                              style={{
                                width: "100%",
                                height: 25,
                              }}
                              defaultValue={"No Tax Applicable"}
                              options={[
                                {
                                  value: "No Tax Applicable",
                                  label: "No Tax Applicable",
                                },
                              ]}
                            />
                          }
                          type="text"
                          prefix={"₹ "}
                          placeholder="0"
                          className="w-[70%] pr-3 h-[25px]"
                        />
                        <CloseCircleOutlined
                          className="w-[10%] pl-3"
                          onClick={() => setAdditionalChargesOpen(false)}
                        />
                      </div>
                    ) : (
                      <div
                        onClick={() => setAdditionalChargesOpen(true)}
                        className="flex justify-between mb-4 text-[#488dff] cursor-pointer"
                      >
                        <div>
                          <PlusOutlined /> Add Additional Charges
                        </div>
                        <div>
                          <h1>₹. 0</h1>
                        </div>
                      </div>
                    )}
                    <div
                      // onClick={() => setAdditionalChargesOpen(true)}
                      className="mt-4 purchase-label flex justify-between mb-3 cursor-pointer"
                    >
                      <h1 className="text-[14px]">Taxable Amount</h1>
                      <p className="text-[14px] font-semibold">₹ 13</p>
                    </div>

                    <div
                      // onClick={() => setAdditionalChargesOpen(true)}
                      className="mt-2 purchase-label mb-3 cursor-pointer"
                    >
                      <div className="w-[100%] flex justify-between">
                        <Checkbox
                          type="checkbox"
                          name="applyTcs"
                          height={14}
                          width={14}
                          // defaultChecked
                          value={applyTcs}
                          onChange={(e) => setApplyTcs(e.target.checked)}
                          className="w-[50%] text-[#084d7b]"
                        >
                          <p className={applyTcs === true ? "mt-2" : ""}>
                            {" "}
                            Apply TCS{" "}
                          </p>
                        </Checkbox>
                        {applyTcs === true ? (
                          <Select
                            style={{
                              width: "50%",
                              height: 40,
                            }}
                            value={tcsList}
                            onChange={(e) => setTcsList(e)}
                            placeholder="Select Tcs Rate"
                            dropdownRender={(menu) => (
                              <>
                                {menu}
                                <Divider
                                  style={{
                                    margin: "8px 0",
                                  }}
                                />
                                <Space
                                  style={{
                                    display: "flex",
                                    justifyContent: "center",
                                  }}
                                >
                                  <Button
                                    type="text"
                                    icon={<PlusOutlined />}
                                    onClick={addItem}
                                  >
                                    Add item
                                  </Button>
                                </Space>
                              </>
                            )}
                            options={[]}
                          />
                        ) : (
                          ""
                        )}
                      </div>
                      {applyTcs === true ? (
                        <div className="w-[100%] flex justify-end">
                          <Radio.Group
                            value={tcsAmount}
                            onChange={(e) => setTcsAmount(e.target.value)}
                            className="flex mt-4 ml-3 mr-3"
                          >
                            <Radio value={"Total Amount"}>Total Amount</Radio>
                            <Radio value={"Taxable Amount"}>
                              Taxable Amount
                            </Radio>
                          </Radio.Group>
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                ) : (
                  <div className="p-6 border border-x-0 border-b-1 border-t-0">
                    {additionalChargesOpen === true ? (
                      <div className="w-[100%] flex mt-3">
                        <Input
                          name="chargesData"
                          value={totalSectionData.chargesData}
                          placeholder="Enter charge(eg: transport charge)"
                          onChange={(e) => handlePurchaseChange(e)}
                          className="w-[70%] pr-2 h-[40px] bg-[#e9ecf1] focus:bg-[#e9ecf1] hover:bg-[#e9ecf1]"
                        />
                        <Input
                          name="additionalCharges"
                          value={totalSectionData.additionalCharges}
                          onChange={(e) => handlePurchaseChange(e)}
                          addonAfter={
                            <Select
                              value={additionalOptions}
                              onChange={(e) => setAdditionalOptions(e)}
                              style={{
                                width: "100%",
                                height: 25,
                              }}
                              defaultValue={"No Tax Applicable"}
                              options={[
                                {
                                  value: "No Tax Applicable",
                                  label: "No Tax Applicable",
                                },
                              ]}
                            />
                          }
                          type="text"
                          prefix={"₹ "}
                          placeholder="0"
                          className="w-[70%] pr-3 h-[25px]"
                        />
                        <CloseCircleOutlined
                          className="w-[10%] pl-3"
                          onClick={() => setAdditionalChargesOpen(false)}
                        />
                      </div>
                    ) : (
                      <div
                        onClick={() => setAdditionalChargesOpen(true)}
                        className="flex justify-between mb-4 text-[#488dff] cursor-pointer"
                      >
                        <div>
                          <PlusOutlined /> Add Additional Charges
                        </div>
                        <div>
                          <h1>₹. 0</h1>
                        </div>
                      </div>
                    )}
                    <div className="mt-4 purchase-label flex justify-between mb-3 cursor-pointer">
                      <h1 className="text-[14px]">Taxable Amount</h1>
                      <p className="text-[14px] font-semibold">₹ 13</p>
                    </div>
                    {discountOpen === true ? (
                      <div className="w-[100%] flex mt-4">
                        <Select
                          value={discount}
                          onChange={(e) => setDiscount(e)}
                          style={{
                            width: "50%",
                            height: 35,
                          }}
                          defaultValue={"Display After Tax"}
                          options={[
                            {
                              value: "Display Before Tax",
                              label: "Display Before Tax",
                            },
                            {
                              value: "Display After Tax",
                              label: "Display After Tax",
                            },
                          ]}
                        />
                        <Tooltip
                          title="Invoice discount will be split among items in the ratio of taxable amount"
                          placement="top"
                        >
                          <InfoCircleOutlined className="ml-3 16px mr-3" />
                        </Tooltip>
                        <Input
                          name="discountPercent"
                          value={totalSectionData.discountPercent}
                          onChange={(e) => handlePurchaseChange(e)}
                          type="text"
                          prefix={"% "}
                          placeholder="0"
                          className=" w-[40%] focus:bg-[#e9ecf1] hover:bg-[#e9ecf1] bg-[#e9ecf1] mr-2 h-[25px]"
                        />
                        <p className="pr-2 pl-2">{" / "}</p>
                        <Input
                          name="discountAmount"
                          value={totalSectionData.discountAmount}
                          onChange={(e) => handleDiscountChange(e)}
                          type="text"
                          prefix={"₹ "}
                          placeholder="0"
                          className="w-[40%] focus:bg-[#e9ecf1] hover:bg-[#e9ecf1] bg-[#e9ecf1] mr-2 h-[25px]"
                        />
                        <CloseCircleOutlined
                          className="w-[15%] pl-5"
                          onClick={() => setDiscountOpen(false)}
                        />
                      </div>
                    ) : (
                      <div className="flex justify-between mb-3 text-[#488dff] cursor-pointer">
                        <div onClick={() => setDiscountOpen(true)}>
                          <PlusOutlined /> Add Discount
                        </div>
                        <div>
                          <h1>-₹. 0</h1>
                        </div>
                      </div>
                    )}
                    <div
                      // onClick={() => setAdditionalChargesOpen(true)}
                      className="mt-2 purchase-label mb-3 cursor-pointer"
                    >
                      <div className="w-[100%] flex justify-between">
                        <Checkbox
                          type="checkbox"
                          name="applyTcs"
                          height={14}
                          width={14}
                          // defaultChecked
                          value={applyTcs}
                          onChange={(e) => setApplyTcs(e.target.checked)}
                          className="w-[50%] text-[#084d7b]"
                        >
                          <p className={applyTcs === true ? "mt-2" : ""}>
                            {" "}
                            Apply TCS{" "}
                          </p>
                        </Checkbox>
                        {applyTcs === true ? (
                          <Select
                            style={{
                              width: "50%",
                              height: 40,
                            }}
                            value={tcsList}
                            onChange={(e) => setTcsList(e)}
                            placeholder="Select Tcs Rate"
                            dropdownRender={(menu) => (
                              <>
                                {menu}
                                <Divider
                                  style={{
                                    margin: "8px 0",
                                  }}
                                />
                                <Space
                                  style={{
                                    display: "flex",
                                    justifyContent: "center",
                                  }}
                                >
                                  <Button
                                    type="text"
                                    icon={<PlusOutlined />}
                                    onClick={addItem}
                                  >
                                    Add item
                                  </Button>
                                </Space>
                              </>
                            )}
                            options={[]}
                          />
                        ) : (
                          ""
                        )}
                      </div>
                      {applyTcs === true ? (
                        <div className="w-[100%] flex justify-end">
                          <Radio.Group
                            value={tcsAmount}
                            onChange={(e) => setTcsAmount(e.target.value)}
                            className="flex mt-4 ml-3 mr-3"
                          >
                            <Radio value={"Total Amount"}>Total Amount</Radio>
                            <Radio value={"Taxable Amount"}>
                              Taxable Amount
                            </Radio>
                          </Radio.Group>
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                )}
                <div className="p-6 border border-x-0 border-b-1 border-t-0">
                  <div
                    // onClick={() => setAdditionalChargesOpen(true)}
                    className="w-[100%] mt-2 purchase-label flex justify-between mb-3 cursor-pointer"
                  >
                    <Checkbox
                      type="checkbox"
                      name="autoRoundfOff"
                      height={14}
                      width={14}
                      // defaultChecked
                      value={autoRoundOff}
                      onChange={(e) => setAutoRoundOff(e.target.checked)}
                      className="w-[50%] text-[#084d7b]"
                    >
                      <p className={autoRoundOff === false ? "mt-2" : ""}>
                        {" "}
                        Auto Round Off{" "}
                      </p>
                    </Checkbox>
                    {autoRoundOff === false ? (
                      <Input
                        name="autoRoundOffValue"
                        value={totalSectionData.autoRoundOffValue}
                        onChange={(e) => handlePurchaseChange(e)}
                        addonBefore={
                          <Select
                            value={autoRoundOffMethod}
                            onChange={(e) => setAutoRoundOffMethod(e)}
                            style={{
                              width: 100,
                              height: 25,
                            }}
                            options={[
                              {
                                value: "Add",
                                label: "+ Add",
                              },
                              {
                                value: "Reduce",
                                label: "- Reduce",
                              },
                            ]}
                          />
                        }
                        type="text"
                        prefix={"₹ "}
                        placeholder="0"
                        className="w-[50%] mb-3 h-[25px]"
                      />
                    ) : (
                      ""
                    )}
                  </div>
                  <div
                    // onClick={() => setAdditionalChargesOpen(true)}
                    className="mt-5 font-semibold purchase-label flex justify-between mb-3 cursor-pointer"
                  >
                    <h1 className="w-[50%] purchase-label text-[14px] mt-1">
                      Total Amount
                    </h1>
                    <Input
                      name="totalAmount"
                      value={totalSectionData.totalAmount}
                      onChange={(e) => handlePurchaseChange(e)}
                      type="text"
                      prefix={"₹ "}
                      placeholder="Enter Payment Amount"
                      className="w-[50%] focus:bg-[#e9ecf1] hover:bg-[#e9ecf1] bg-[#e9ecf1] h-[25px]"
                    />
                  </div>
                </div>

                {/* amount fully paid section */}
                <div
                  // onClick={() => setAdditionalChargesOpen(true)}
                  className="mt-2 mb-2 border border-b-1 border-x-0 border-t-0 purchase-label mb-3 cursor-pointer"
                >
                  <div className="mb-2 flex purchase-label text-[12px] justify-end pr-3">
                    Mark as Fully Paid
                    <Checkbox
                      type="checkbox"
                      name="fullyPaid"
                      height={14}
                      width={14}
                      // defaultChecked
                      value={fullyPaid}
                      onChange={(e) => setFullyPaid(e.target.checked)}
                      className="pl-2 text-[#084d7b]"
                    />
                  </div>
                  <div className="mt-2 w-[100%] pr-3 pl-3 pt-3 mb-3 flex justify-between">
                    <h1 className="w-[40%] purchase-label text-[12px] pl-3 mt-2">
                      Amount Paid
                    </h1>
                    <Input
                      name="amountPaid"
                      value={totalSectionData.amountPaid}
                      disabled={fullyPaid === true ? true : false}
                      onChange={(e) => handlePurchaseChange(e)}
                      addonAfter={
                        <Select
                          value={amountPaidList}
                          disabled={fullyPaid === true ? true : false}
                          onChange={(e) => setAmountPaidList(e)}
                          style={{
                            width: 100,
                            height: 25,
                          }}
                          defaultValue={"Cash"}
                          options={[
                            {
                              value: "Cash",
                              label: "Cash",
                            },
                            {
                              value: "Bank",
                              label: "Bank",
                            },
                            {
                              value: "Cheque",
                              label: "Cheque",
                            },
                          ]}
                        />
                      }
                      type="text"
                      prefix={"₹ "}
                      placeholder="0"
                      className="w-[60%] h-[25px] focus:bg-[#e9ecf1] hover:bg-[#e9ecf1] bg-[#e9ecf1]"
                    />
                  </div>
                  <div className="pr-3 pl-5 pt-3 mt-4 mb-6 w-[100%] flex justify-between">
                    <Checkbox
                      type="checkbox"
                      name="applyTds"
                      height={14}
                      width={14}
                      // defaultChecked
                      value={applyTds}
                      onChange={(e) => setApplyTds(e.target.checked)}
                      className="w-[30%] text-[#084d7b]"
                    >
                      <p className={applyTds === true ? "mt-2" : ""}>
                        {" "}
                        Apply TDS{" "}
                      </p>
                    </Checkbox>
                    {applyTds === true ? (
                      <Select
                        style={{
                          width: "65%",
                          height: 35,
                        }}
                        value={tdsList}
                        onChange={(e) => setTdsList(e)}
                        placeholder="Select Tds Rate"
                        dropdownRender={(menu) => (
                          <>
                            {menu}
                            <Divider
                              style={{
                                margin: "8px 0",
                              }}
                            />
                            <Space
                              style={{
                                display: "flex",
                                justifyContent: "center",
                              }}
                            >
                              <Button
                                type="text"
                                icon={<PlusOutlined />}
                                onClick={addTdsItem}
                              >
                                Add item
                              </Button>
                            </Space>
                          </>
                        )}
                        options={[]}
                      />
                    ) : (
                      ""
                    )}
                  </div>
                </div>

                {/* Balance */}
                <div
                  // onClick={() => setAdditionalChargesOpen(true)}
                  className="mt-3 pt-3 pb-3 pl-5 pr-4 flex justify-between text-[#2cc646] text-[14px] mb-2 border border-b-1 border-x-0 border-t-0 purchase-label mb-3 cursor-pointer"
                >
                  <h1>Balance</h1>
                  <p>0</p>
                </div>
                <div
                  // onClick={() => setAdditionalChargesOpen(true)}
                  className="mt-3 p-3 text-[14px] mb-2 purchase-label mb-3 cursor-pointer"
                >
                  <div className="flex justify-end">
                    <h1>Authorized signatory for</h1>
                    <p className="font-semibold ml-2">MEQUALS TECH</p>
                  </div>
                  <div className="flex justify-end mt-2 mb-2 ml-10">
                    <Upload
                      action="https://660d2bd96ddfa2943b33731c.mockapi.io/api/upload"
                      listType="picture-card"
                      fileList={fileList}
                      onPreview={handlePreview}
                      onChange={handleImageChange}
                    >
                      {fileList.length >= 1 ? null : uploadButton}
                    </Upload>
                    {previewImage && (
                      <Image
                        wrapperStyle={{
                          display: "none",
                        }}
                        preview={{
                          visible: previewOpen,
                          onVisibleChange: (visible) => setPreviewOpen(visible),
                          afterOpenChange: (visible) =>
                            !visible && setPreviewImage(""),
                        }}
                        src={previewImage}
                      />
                    )}
                  </div>
                </div>
              </Col>
            </Row>
          </Col>
        </div>

        {/* Custom fields modal */}
        <Modal
          open={columnSettings}
          title="Show/Hide Columns in Invoice"
          onOk={() => setColumnSettings(false)}
          closeIcon
          maskClosable={false}
          okText={"Save"}
          className="mt-[-70px]"
          onCancel={() => setColumnSettings(false)}
          footer={(_, { OkBtn, CancelBtn }) => (
            <>
              <CancelBtn />
              <OkBtn />
            </>
          )}
        >
          <Divider
            // className="w-[110%] ml-[-24px]"
            style={{
              borderWidth: "0.2px",
              width: "110%",
              marginLeft: "-24px",
              marginTop: "-3px",
            }}
          />
          <Col className="mb-3">
            <div className="purchase-label flex uppercase text-[12px] bg-[#cdcccc63] mb-1 p-2 border border-b-1 border-x-0 border-t-0 justify-between">
              <h1 className="">Column Name</h1>
              <p>Show</p>
            </div>

            <div
              className={
                "purchase-label flex text-[12px] bg-[white] mb-1 p-2 border border-b-1 border-x-0 border-t-0 justify-between"
              }
            >
              <h1>Price/ Item(₹)</h1>
              <Switch
                value={purchaseData.price}
                onChange={(checked) =>
                  setPurchaseData({
                    ...purchaseData,
                    price: checked,
                  })
                }
              />
            </div>
            <div
              className={
                "purchase-label flex text-[12px] bg-[white] mb-1 p-2 border border-b-1 border-x-0 border-t-0 justify-between"
              }
            >
              <h1>Quantity</h1>
              <Switch
                value={purchaseData.quantity}
                onChange={(checked) =>
                  setPurchaseData({
                    ...purchaseData,
                    quantity: checked,
                  })
                }
              />
            </div>
            <div className="purchase-label mt-[-5px] flex uppercase text-[12px] bg-[#cdcccc63] mb-1 p-2 border border-b-1 border-x-0 border-t-0 justify-between">
              <h1 className="">Custom Column Name</h1>
              <p>Show</p>
            </div>
            <div
              className={
                "purchase-label flex text-[12px] bg-[white] mb-1 p-2 border border-b-1 border-x-0 border-t-0 justify-between"
              }
            >
              <h1>Travel</h1>
              <Switch
                value={purchaseData.travel}
                onChange={(checked) =>
                  setPurchaseData({
                    ...purchaseData,
                    travel: checked,
                  })
                }
              />
            </div>
            <div
              className={
                "purchase-label flex text-[12px] bg-[white] mb-1 p-2 border border-b-1 border-x-0 border-t-0 justify-between"
              }
            >
              <h1>Batch No</h1>
              <Switch
                value={purchaseData.batch}
                onChange={(checked) =>
                  setPurchaseData({
                    ...purchaseData,
                    batch: checked,
                  })
                }
              />
            </div>
            <div
              className={
                "purchase-label flex text-[12px] bg-[white] mb-1 p-2 border border-b-1 border-x-0 border-t-0 justify-between"
              }
            >
              <h1>Expiry Date</h1>
              <Switch
                value={purchaseData.expiryDate}
                onChange={(checked) =>
                  setPurchaseData({
                    ...purchaseData,
                    expiryDate: checked,
                  })
                }
              />
            </div>
            <div
              className={
                "purchase-label flex text-[12px] bg-[white] mb-1 p-2 border border-b-1 border-x-0 border-t-0 justify-between"
              }
            >
              <h1>mfgDate</h1>
              <Switch
                value={purchaseData.mfgDate}
                onChange={(checked) =>
                  setPurchaseData({
                    ...purchaseData,
                    mfgDate: checked,
                  })
                }
              />
            </div>
          </Col>
          <Col
            span={24}
            className="mt-3 mb-2 flex bg-[#ffb8001a] purchase-label text-[10px] terms-conditions-card mb-3 mt-1 pr-3"
          >
            <h1 className="flex font-bold ml-10">
              <p className="flex font-medium ml-2">
                To add Custom Item Columns - Go to Item settings from
                <p className="cursor-pointer flex ml-1 text-[blue]">
                  Items page (click here)
                </p>
              </p>
            </h1>
          </Col>
        </Modal>
        {/* settings Field Modal */}
        <Modal
          open={settingsFieldModal}
          title="Quick Debit Note Settings"
          onOk={handleOk}
          closeIcon
          maskClosable={false}
          okText={"Save"}
          onCancel={handleCancel}
          footer={(_, { OkBtn, CancelBtn }) => (
            <>
              <CancelBtn />
              <OkBtn />
            </>
          )}
        >
          <Divider
            style={{ borderWidth: "0.2px", width: "110%", marginLeft: "-24px" }}
          />
          <Col span={24}>
            <div className="w-[100%] flex justify-between mb-2 mt-[-15px]">
              <h1 className="purchase-label text-[16px]">
                Debit Note Prefix & Invoice Number
              </h1>
              <Switch
                value={invoiceShow}
                onChange={(checked) => setInvoiceShow(checked)}
              />
            </div>
            {invoiceShow ? (
              <Row className="mt-2">
                <Col span={8} className="pr-3">
                  <Typography className="purchase-label mb-1">
                    Prefix
                  </Typography>
                  <Input
                    name="prefix"
                    value={purchaseSettings.prefix}
                    onChange={(e) => handleChange(e)}
                    placeholder="Enter Prefix purchase-label"
                    className="p-2"
                  />
                </Col>
                <Col span={8}>
                  <Typography className="mb-1 purchase-label">
                    Sequence Number
                  </Typography>
                  <Input
                    name="seqNo"
                    value={purchaseSettings.seqNo}
                    onChange={(e) => handleChange(e)}
                    placeholder="Enter Seq No"
                    className="p-2 purchase-label"
                  />
                </Col>
                <Col span={24} className="mt-2">
                  <Typography className="purchase-label mb-1">
                    Debit Note Number:{" "}
                    {!isEmpty(purchaseSettings.seqNo)
                      ? purchaseSettings.seqNo
                      : ""}
                  </Typography>
                </Col>
              </Row>
            ) : (
              ""
            )}
          </Col>

          <Divider
            style={{ borderWidth: "0.2px", width: "110%", marginLeft: "-24px" }}
          />
        </Modal>

        {/* create party modal */}

        <Modal
          open={createPartyModal}
          title="Create New Party"
          onOk={() => setCreatePartyModal(false)}
          closeIcon
          maskClosable={false}
          okText={"Save"}
          width={600}
          className="mt-[-70px]"
          onCancel={() => setCreatePartyModal(false)}
          footer={(_, { OkBtn, CancelBtn }) => (
            <>
              <CancelBtn />
              <OkBtn />
            </>
          )}
        >
          <Divider
            style={{ borderWidth: "0.2px", width: "109%", marginLeft: "-24px" }}
          />
          <Col span={24}>
            <Row className="mt-2 mb-2">
              <Col span={24} className="">
                <Typography className="text-[gray] input-required-label uppercase flex">
                  Party Name <p className="text-[red]">*</p>
                </Typography>
                <Input
                  name="name"
                  value={partyModalData.name}
                  onChange={(e) => handleModalChange(e)}
                  placeholder="Enter name"
                  className="p-2"
                />
              </Col>
              <Col span={24} className="mt-2">
                <Typography className="text-[gray] input-label mb-1 uppercase">
                  Mobile Number
                </Typography>
                <Input
                  name="mobile"
                  value={partyModalData.mobile}
                  onChange={(e) => handleModalChange(e)}
                  placeholder="Enter Mobile No"
                  className="p-2"
                />
              </Col>
              <Col span={24} className="mt-3">
                <div className="">
                  {addAddressShow === true ? (
                    <Row>
                      <Col
                        span={24}
                        className="mt-2 bg-[#f3f3f3] rounded-md p-2 flex justify-between cursor-pointer"
                      >
                        <h1>Add Address (Optional)</h1>
                        <p
                          className="text-[#df121c]"
                          onClick={() => setAddAddressShow(false)}
                        >
                          Remove
                        </p>
                      </Col>
                      <Col span={24} className="mt-3">
                        <Typography className="text-[gray] flex input-required-label uppercase">
                          Billing Address <p className="text-[#df121c]">*</p>
                        </Typography>
                        <Input.TextArea
                          name="billingAddress"
                          value={partyModalData.billingAddress}
                          onChange={(e) => handleModalChange(e)}
                          placeholder="Enter Billing Address"
                          className="p-3 h-[35px]"
                        />
                      </Col>
                      <Col span={12} className="mt-2 pr-3">
                        <Typography className="text-[gray] input-label uppercase mb-1">
                          State
                        </Typography>
                        <Select
                          style={{
                            width: 250,
                            height: 40,
                          }}
                          value={stateData}
                          onChange={(e) => setStateData(e)}
                          placeholder="Select State"
                          options={[
                            {
                              value: "Tamil Nadu",
                              label: "Tamil Nadu",
                            },
                            {
                              value: "Karnataka",
                              label: "Karnataka",
                            },
                            {
                              value: "Kerala",
                              label: "Kerala",
                            },
                          ]}
                        />
                      </Col>
                      <Col span={12} className="mt-2 pl-3">
                        <Typography className="text-[gray] input-label uppercase mb-1">
                          Pincode
                        </Typography>
                        <Input
                          name="pincode"
                          value={pincode}
                          onChange={(e) => {
                            const name = "pincode";
                            const validationRules = {
                              pincode: /^[0-9]*$/,
                            };
                            if (validationRules[name]) {
                              if (
                                validationRules[name].test(e.target.value) ||
                                e.target.value === ""
                              ) {
                                setPincode(e.target.value);
                              }
                            }

                            axios
                              .get(
                                `https://api.postalpincode.in/pincode/${e.target.value}`
                              )
                              .then((res) => {
                                console.log(res, "res");
                                if (e.target.value.length === 6) {
                                  setPartyModalData({
                                    ...partyModalData,
                                    cityName:
                                      res &&
                                      res.data &&
                                      res.data.length > 0 &&
                                      res.data[0].PostOffice !== null
                                        ? res.data[0].PostOffice[0].District
                                        : "",
                                  });
                                } else {
                                  setPartyModalData({
                                    ...partyModalData,
                                    cityName: "",
                                  });
                                }
                              });
                          }}
                          maxLength={6}
                          placeholder="Enter pincode"
                          className="p-2 text-semibold"
                        />
                      </Col>
                      <Col span={24} className="mt-2">
                        <Typography className="text-[gray] input-label uppercase">
                          City
                        </Typography>
                        <Input
                          name="cityName"
                          value={partyModalData.cityName}
                          onChange={(e) => handleModalChange(e)}
                          placeholder="Enter City"
                          className="p-2 text-semibold"
                        />
                      </Col>
                      <Col span={24} className="mt-3 mb-1">
                        <div className="flex">
                          <Checkbox
                            type="checkbox"
                            name="sameAs"
                            height={14}
                            width={14}
                            defaultChecked
                            value={sameAs}
                            onChange={(e) => setSameAs(e.target.checked)}
                            className="text-[#084d7b]"
                          >
                            Same as Billing Address
                          </Checkbox>
                        </div>
                      </Col>
                    </Row>
                  ) : (
                    <div
                      onClick={() => setAddAddressShow(true)}
                      className="mb-3 text-[#488dff] cursor-pointer"
                    >
                      <PlusOutlined /> Add Address (Optional)
                    </div>
                  )}
                  {addGstShow === true ? (
                    <Row>
                      <Col
                        span={24}
                        className="mt-2 bg-[#f3f3f3] rounded-md p-2 flex justify-between cursor-pointer"
                      >
                        <h1>Add GST (Optional)</h1>
                        <p
                          className="text-[#df121c]"
                          onClick={() => setAddGstShow(false)}
                        >
                          Remove
                        </p>
                      </Col>

                      <Col span={24} className="mt-2">
                        <Typography className="text-[gray] input-label uppercase">
                          GSTIN
                        </Typography>
                        <Input
                          name="gstIn"
                          value={partyModalData.gstIn}
                          onChange={(e) => handleModalChange(e)}
                          placeholder="Enter gstIn"
                          className="p-2 text-semibold"
                        />
                      </Col>
                    </Row>
                  ) : (
                    <div
                      onClick={() => setAddGstShow(true)}
                      className="mt-3 text-[#488dff] cursor-pointer"
                    >
                      <PlusOutlined /> Add GSTIN (Optional)
                    </div>
                  )}
                </div>
              </Col>
            </Row>
          </Col>
          <Col
            span={24}
            className="mt-3 mb-2 bg-[#ffb8001a] purchase-label text-[12px] terms-conditions-card pr-3"
          >
            <h1 className="flex justify-center font-bold ml-15">
              <p className="flex font-medium ml-2">
                You can add Custom Fields from
                <p className="cursor-pointer flex ml-1 text-[blue]">
                  Party settings
                </p>
              </p>
            </h1>
          </Col>

          <Divider
            style={{ borderWidth: "0.2px", width: "109%", marginLeft: "-24px" }}
          />
        </Modal>
        {/* Tcs rate Modal */}
        <Modal
          open={tcsRateModal}
          title="Add Tcs Rate"
          onOk={() => setTcsRateModal(false)}
          closeIcon
          maskClosable={false}
          okText={"Save"}
          onCancel={() => setTcsRateModal(false)}
          footer={(_, { OkBtn, CancelBtn }) => (
            <>
              <CancelBtn />
              <OkBtn />
            </>
          )}
        >
          <Divider
            style={{ borderWidth: "0.2px", width: "110%", marginLeft: "-24px" }}
          />
          <Col span={24} className="mt-[-10px]">
            <Row className="mt-2">
              <Col span={24} className="mb-3">
                <Typography className="mb-1">Tax Name</Typography>
                <Input
                  name="tcsTaxName"
                  value={totalSectionData.tcsTaxName}
                  onChange={(e) => handlePurchaseChange(e)}
                  placeholder="Enter Tax Name"
                  className="p-2"
                />
              </Col>
              <Col span={24} className="mb-3">
                <Typography className="mb-1">Section Name</Typography>
                <Input
                  name="tcsSectionName"
                  value={totalSectionData.tcsSectionName}
                  onChange={(e) => handlePurchaseChange(e)}
                  placeholder="Enter Section Name"
                  className="p-2"
                />
              </Col>
              <Col span={24} className="mb-3">
                <Typography className="mb-1">Enter Rate (%)</Typography>
                <Input
                  name="tcsRatePercent"
                  value={totalSectionData.tcsRatePercent}
                  onChange={(e) => handlePurchaseChange(e)}
                  placeholder="Enter Rate"
                  className="p-2"
                />
                <Typography className="mb-1 text-[red] text-[12px]">
                  {totalSectionData.tcsRatePercent > 100
                    ? "Please enter a rate between 0 and 100"
                    : ""}
                </Typography>
              </Col>
            </Row>
          </Col>

          <Divider
            style={{ borderWidth: "0.2px", width: "110%", marginLeft: "-24px" }}
          />
        </Modal>
        {/* Tds rate Modal */}
        <Modal
          open={tdsRateModal}
          title="Add Tds Rate"
          onOk={() => setTdsRateModal(false)}
          closeIcon
          maskClosable={false}
          okText={"Save"}
          onCancel={() => setTdsRateModal(false)}
          footer={(_, { OkBtn, CancelBtn }) => (
            <>
              <CancelBtn />
              <OkBtn />
            </>
          )}
        >
          <Divider
            style={{ borderWidth: "0.2px", width: "110%", marginLeft: "-24px" }}
          />
          <Col span={24} className="mt-[-10px]">
            <Row className="mt-2">
              <Col span={24} className="mb-3">
                <Typography className="mb-1">Tax Name</Typography>
                <Input
                  name="tdsTaxName"
                  value={totalSectionData.tdsTaxName}
                  onChange={(e) => handlePurchaseChange(e)}
                  placeholder="Enter Tax Name"
                  className="p-2"
                />
              </Col>
              <Col span={24} className="mb-3">
                <Typography className="mb-1">Section Name</Typography>
                <Input
                  name="tdsSectionName"
                  value={totalSectionData.tdsSectionName}
                  onChange={(e) => handlePurchaseChange(e)}
                  placeholder="Enter Section Name"
                  className="p-2"
                />
              </Col>
              <Col span={24} className="mb-3">
                <Typography className="mb-1">Enter Rate (%)</Typography>
                <Input
                  name="tdsRatePercent"
                  value={totalSectionData.tdsRatePercent}
                  onChange={(e) => handlePurchaseChange(e)}
                  placeholder="Enter Rate"
                  className="p-2"
                />
                <Typography className="mb-1 text-[red] text-[12px]">
                  {totalSectionData.tdsRatePercent > 100
                    ? "Please enter a rate between 0 and 100"
                    : ""}
                </Typography>
              </Col>
            </Row>
          </Col>

          <Divider
            style={{ borderWidth: "0.2px", width: "110%", marginLeft: "-24px" }}
          />
        </Modal>

        {/* item create Modal */}
        <Modal
          open={itemModal}
          title="Add Items"
          onOk={() => setItemModal(false)}
          closeIcon
          maskClosable={false}
          okText={"Done"}
          width={"80%"}
          className="mt-[-40px]"
          onCancel={() => setItemModal(false)}
          footer={(_, { OkBtn, CancelBtn }) => (
            <>
              <CancelBtn />
              <OkBtn />
            </>
          )}
        >
          <Divider className="purchase-divider" />
          <Col span={24} className="mt-[-10px]">
            <Row>
              <Col span={8} className="pr-3">
                <AutoComplete
                  options={itemOptions}
                  style={{
                    width: "100%",
                    marginRight: "10px",
                    borderRadius: "2px",
                  }}
                  onSelect={onItemsSelect}
                  onSearch={(text) => setItemOptions(getItemPanelValue(text))}
                >
                  <Input.Search size="large" placeholder="Search Items" />
                </AutoComplete>
              </Col>
              {scanQrModal === true ? (
                <Col span={6} className="pr-3"></Col>
              ) : (
                <Col span={6} className="pr-3">
                  <Select
                    style={{
                      width: "100%",
                      height: 40,
                    }}
                    value={itemCategory}
                    onChange={(e) => setItemCategory(e)}
                    placeholder="Select Category"
                    dropdownRender={(menu) => (
                      <>
                        {menu}
                        <Divider
                          style={{
                            margin: "8px 0",
                          }}
                        />
                      </>
                    )}
                    options={[]}
                  />
                </Col>
              )}

              <Col span={10}>
                {" "}
                <div
                  onClick={() => setCreateItemModal(true)}
                  className="w-[100%] border text-[#1677ff] border-blue-400 text-center  rounded-md pl-8 pr-8 p-2 cursor-pointer"
                >
                  <PlusOutlined className="mr-1" /> Create New Item
                </div>
              </Col>
            </Row>
            <Row>
              <Col span={24} className={"add-create-item-main mt-3"}>
                <table className="table-purchase-serial table-responsive">
                  <thead>
                    <tr>
                      <th className="table-purchase-head uppercase text-[12px] font-medium">
                        Item Name
                      </th>
                      <th className="table-purchase-head uppercase text-[12px] font-medium">
                        Item Code
                      </th>
                      <th className="table-purchase-head uppercase text-[12px] font-medium">
                        Sales Price
                      </th>
                      {purchaseColumn === true ? (
                        ""
                      ) : (
                        <th className="table-purchase-head mt-1 flex uppercase text-[12px] font-medium">
                          <h1> Purchase Price </h1>{" "}
                          <CloseCircleOutlined
                            onClick={() => setPurchasePriceModal(true)}
                            className="text-[10px] ml-2 text-[black]"
                          />
                        </th>
                      )}

                      <th className="table-purchase-head uppercase text-[12px] font-medium">
                        Current Stock
                      </th>
                      <th className="table-purchase-head uppercase text-[12px] font-medium">
                        Quantity
                      </th>

                      {/* <th className="table-head uppercase text-[12px] font-medium">
                        <div
                          className="cursor-pointer"
                          onClick={() => setColumnSettings(true)}
                        >
                          
                        </div>
                      </th> */}
                    </tr>
                  </thead>
                  <tbody>
                    {scanQrModal === true ? (
                      <tr key={0} className="text-center">
                        <td
                          colSpan={7}
                          className="cursor-pointer text-center pt-5 pb-5 pl-5 pr-5"
                        >
                          <Image
                            src={qrCodeLogo}
                            preview={false}
                            width={350}
                            height={100}
                          />
                        </td>
                      </tr>
                    ) : (
                      <>
                        {createItemTableData.map((data, index) => {
                          return (
                            <tr key={index} className="table-purchase-row">
                              <td
                                className="table-purchase-data flex"
                                // onClick={() => setExpandable(true)}
                              >
                                <Checkbox
                                  type="checkbox"
                                  // name="autoRoundfOff"
                                  height={14}
                                  width={14}
                                  // defaultChecked
                                  // value={autoRoundOff}
                                  // onChange={(e) =>
                                  //   setAutoRoundOff(e.target.checked)
                                  // }
                                  className="mr-2 text-[#084d7b]"
                                />
                                <p className="mt-1">{data.itemName}</p>
                              </td>
                              <td className="table-purchase-data">
                                {data.itemCode}
                              </td>
                              <td className="table-purchase-data">
                                {data.salesPrice}
                              </td>
                              {purchaseColumn === true ? (
                                ""
                              ) : (
                                <td className="table-purchase-data">
                                  {data.purchasePrice}
                                </td>
                              )}

                              <td className="uppercase font-semibold table-purchase-data">
                                {data.itemName === "Fish" ? (
                                  <div
                                    onClick={() => setBatchingModal(true)}
                                    className="w-[100%] border font-medium text-[#1677ff] border-blue-400 text-center  rounded-md pl-8 pr-8 p-2 cursor-pointer"
                                  >
                                    <PlusOutlined className="mr-1" /> Create New
                                    Batch
                                  </div>
                                ) : (
                                  data.currentStock
                                )}
                              </td>
                              <td className="table-purchase-data">
                                {data.itemName === "Fish" ? (
                                  <div
                                    onClick={() => setBatchingModal(true)}
                                    className="w-[100%] border text-[#1677ff] border-blue-400 text-center  rounded-md pl-8 pr-8 p-2 cursor-pointer"
                                  >
                                    Show Batches{" "}
                                    <DownOutlined className="ml-1" />
                                  </div>
                                ) : quantityCount === true &&
                                  data.itemName === "Country Eggs" ? (
                                  <div className="w-[100%] flex justify-between border border-1 text-center rounded-md p-1 cursor-pointer">
                                    <div className="flex">
                                      <p
                                        onClick={() =>
                                          setQuantityCountValue(
                                            quantityCountValue - 1
                                          )
                                        }
                                        className="pl-3 pr-3 p-1 rounded-md bg-[#488dff] text-[#ffffff]"
                                      >
                                        <h1 className="text-[15px] purchase-label font-semibold">
                                          -
                                        </h1>
                                      </p>
                                      <h1 className="text-[14px] font-semibold purchase-label pt-1 pr-3 pl-3">
                                        {quantityCountValue}
                                      </h1>
                                      <p
                                        onClick={() =>
                                          setQuantityCountValue(
                                            quantityCountValue + 1
                                          )
                                        }
                                        className="pl-3 pr-3 p-1 rounded-md bg-[#488dff] text-[#ffffff]"
                                      >
                                        <h1 className="text-[15px] purchase-label font-semibold">
                                          +
                                        </h1>
                                      </p>
                                    </div>
                                    <div className="bg-[#f8f9fc] border border-r-0 border-y-0 border-l-2 p-1 pl-4 pr-4">
                                      <h1 className="pl-2">PCS</h1>
                                    </div>
                                    {/* <PlusOutlined className="mr-1" /> Add */}
                                  </div>
                                ) : (
                                  <div
                                    onClick={() => {
                                      if (data.itemName === "Country Eggs") {
                                        setQuantityCount(true);
                                      } else {
                                        setQuantityShow(true);
                                      }
                                    }}
                                    className="w-[100%] border-none bg-[#daedf3] text-[#1677ff]  text-center  rounded-md pl-8 pr-8 p-2 cursor-pointer"
                                  >
                                    <PlusOutlined className="mr-1" /> Add
                                  </div>
                                )}
                              </td>
                            </tr>

                            // <>
                            //   {expandable === true ? (
                            //     <tr key={0}>
                            //       <td colSpan={7} className="text-center">
                            //         No Data Found
                            //       </td>
                            //     </tr>
                            //   ) : (
                            //     ""
                            //   )}
                            // </>
                          );
                        })}
                      </>
                    )}
                  </tbody>
                </table>
              </Col>
            </Row>
          </Col>

          <Divider
            style={{
              borderWidth: "0.1px",
              width: "104.5%",
              marginLeft: "-24px",
            }}
          />
        </Modal>

        {/* Add Serial Numbers Modal */}
        <Modal
          open={quantityShow}
          title="Add Serial Numbers"
          onOk={() => setQuantityShow(false)}
          closeIcon
          maskClosable={false}
          okText={"Save"}
          onCancel={() => setQuantityShow(false)}
          footer={(_, { OkBtn, CancelBtn }) => (
            <>
              <CancelBtn />
              <OkBtn />
            </>
          )}
        >
          <Divider
            style={{
              borderWidth: "0.2px",
              width: "110%",
              marginLeft: "-24px",
              marginTop: "-6px",
            }}
          />
          <Col span={24}>
            <Row>
              <Col span={24} className="pr-4 mb-2">
                <Typography className="purchase-label mb-2">
                  Item Name
                </Typography>
                <Typography className="purchase-label font-semibold text-[14px] mb-1">
                  Crab
                </Typography>
              </Col>
              <Col span={12} className="pr-4 mb-2">
                <Typography className="purchase-label mb-1">
                  {" "}
                  Quantity
                </Typography>

                <Input
                  name="serialOpenStock"
                  value={serialOpenStock}
                  onChange={(e) => setSerialOpenStock(e.target.value)}
                  suffix={
                    <div className="bg-[#e9e9e9] h-[38px] mr-[-5px] pr-[6px] pl-[6px]">
                      {" "}
                      <h1 className="mt-[-15px] h-[20px]">PCS</h1>
                    </div>
                  }
                  type="text"
                  className="item-stock"
                  placeholder=""
                />
              </Col>

              <Col span={24} className="pr-4 mb-2">
                <div>
                  <table className="table-purchase-serial table-responsive">
                    <thead>
                      <tr className="table-row">
                        <th className="table-head">IMEI/Serial No</th>
                        <th className="table-head">Date Created</th>
                        <th className="table-head"></th>
                      </tr>
                    </thead>
                    <tbody>
                      {serialData.map((data, index) => {
                        return (
                          <tr key={index} className="">
                            <td className="table-data flex justify-between">
                              <Input
                                name="serialNo"
                                value={data.fieldName}
                                placeholder="Enter Custom Field name"
                                // className="w-[90%]"
                                onChange={(e) =>
                                  handleSerialDataChange(e, "serialNo", index)
                                }
                              />
                            </td>
                            <td className="table-data">
                              {moment().format("Do MMM YYYY")}{" "}
                            </td>
                            <td className="table-data">
                              {" "}
                              <DeleteOutlined
                                onClick={() => removeSerialData(index)}
                                type="primary"
                                className="ml-3 p-2 cursor-pointer"
                                size={"large"}
                              />{" "}
                            </td>
                          </tr>
                        );
                      })}

                      <tr>
                        <td className="table-data">
                          <div
                            onClick={() => addSerialData()}
                            className="cursor-pointer text-[#1677ff]"
                          >
                            <PlusOutlined className="mr-2" />
                            Add New Serial No
                          </div>
                        </td>
                        <td className="table-data" colSpan={2}>
                          <div className="flex">
                            <BiQrScan className="mr-2 mt-1" />
                            <p>Scan Serial No</p>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </Col>
            </Row>
          </Col>

          <Divider
            style={{
              borderWidth: "0.2px",
              marginTop: "-8px",
              width: "110%",
              marginLeft: "-24px",
            }}
          />
        </Modal>

        {/* Add batching Modal */}
        <Modal
          open={batchingModal}
          title="Create New Batch"
          onOk={() => setBatchingModal(false)}
          closeIcon
          maskClosable={false}
          okText={"Save"}
          onCancel={() => setBatchingModal(false)}
          footer={(_, { OkBtn, CancelBtn }) => (
            <>
              <CancelBtn />
              <OkBtn />
            </>
          )}
        >
          <Divider
            style={{
              borderWidth: "0.2px",
              width: "110%",
              marginLeft: "-24px",
              marginTop: "-6px",
            }}
          />
          <Col span={24}>
            <Row className="mt-2 mb-2">
              <Col span={24} className="pr-4 mb-2">
                <Typography className="purchase-label flex">
                  Batch No <p className="text-[red] ml-1">*</p>
                </Typography>

                <Input
                  // name="toCollectAmount"
                  // value={partyData.toCollectAmount}

                  // onChange={(e) => handleChange(e)}

                  type="text"
                  className="p-2"
                  placeholder="Batch #1"
                />
              </Col>
              <Col span={24} className="pr-4 mb-2">
                <Typography className="purchase-label mb-1">
                  {" "}
                  Sales Price
                </Typography>

                <Input
                  // name="serialOpenStock"
                  // value={serialOpenStock}
                  // onChange={(e) => setSerialOpenStock(e.target.value)}
                  addonAfter={"With Tax"}
                  // onChange={(e) => setSerialOpenStock(e.target.value)}
                  suffix={"/PCS"}
                  type="text"
                  className="item-stock ml-[-5px]"
                  placeholder="Enter Sales Price"
                />
              </Col>
              <Col span={24} className="pr-4 mb-2">
                <Typography className="purchase-label mb-1">
                  {" "}
                  Purchase Price
                </Typography>

                <Input
                  // name="serialOpenStock"
                  // value={serialOpenStock}
                  addonAfter={"With Tax"}
                  // onChange={(e) => setSerialOpenStock(e.target.value)}
                  suffix={"/PCS"}
                  type="text"
                  className="item-stock  ml-[-5px]"
                  placeholder="Enter Purchase Price"
                />
              </Col>

              <Col span={12} className="pr-4 mb-2">
                <Typography className="purchase-label mb-1 flex">
                  {" "}
                  Opening Stock
                </Typography>

                <Input
                  // name="toCollectAmount"
                  // value={partyData.toCollectAmount}
                  // onChange={(e) => handleChange(e)}

                  suffix={
                    <div className="bg-[#e9e9e9] h-[38px] mr-[-5px] pr-[4px] pl-[4px]">
                      {" "}
                      <h1 className="mt-[-15px] h-[20px]">PCS</h1>
                    </div>
                  }
                  type="text"
                  className="item-stock"
                  placeholder="0"
                />
              </Col>
              <Col span={12} className="pr-4 mb-2">
                <Typography className="purchase-label mb-1 flex">
                  As of Date
                </Typography>

                <DatePicker
                  placement="bottom left"
                  popupClassName="min-h-[30%]"
                  value={asOfDate}
                  onChange={(date, dateString, id) => {
                    console.log(date, dateString, id, "date");
                    if (dateString) {
                      setAsOfDate(dateString);
                    } else {
                      setAsOfDate("");
                    }
                  }}
                  className="w-[100%] p-2 font-normal"
                  placeholder="Select Date"
                />
              </Col>
              <Col span={12} className="pr-4 mb-2">
                <Typography className="purchase-label mb-1 flex">
                  Expiry Date
                </Typography>

                <DatePicker
                  placement="bottom left"
                  popupClassName="min-h-[30%]"
                  // value={asOfDate}
                  // onChange={(date, dateString, id) => {
                  //   console.log(date, dateString, id, "date");
                  //   if (dateString) {
                  //     setAsOfDate(dateString);
                  //   } else {
                  //     setAsOfDate("");
                  //   }
                  // }}
                  className="w-[100%] p-2 font-normal"
                  placeholder="Select Expiry Date"
                />
              </Col>
              <Col span={12} className="pr-4 mb-2">
                <Typography className="purchase-label mb-1 flex">
                  Mfg Date
                </Typography>

                <DatePicker
                  placement="bottom left"
                  popupClassName="min-h-[30%]"
                  // value={asOfDate}
                  // onChange={(date, dateString, id) => {
                  //   console.log(date, dateString, id, "date");
                  //   if (dateString) {
                  //     setAsOfDate(dateString);
                  //   } else {
                  //     setAsOfDate("");
                  //   }
                  // }}
                  className="w-[100%] p-2 font-normal"
                  placeholder="Manufacturing Date"
                />
              </Col>
              <Col span={12} className="pr-4 mb-2">
                <Typography className="purchase-label mb-1">Travel</Typography>

                <Input
                  // name="serialOpenStock"
                  // value={serialOpenStock}

                  type="text"
                  placeholder="Custom Value"
                />
              </Col>
            </Row>
          </Col>

          <Divider
            style={{
              borderWidth: "0.2px",
              marginTop: "-8px",
              width: "110%",
              marginLeft: "-24px",
            }}
          />
        </Modal>

        {/* Purchase price Modal */}
        <Modal
          open={purchasePriceModal}
          title="Hide the Purchase price"
          onOk={() => {
            setPurchaseColumn(true);
            setPurchasePriceModal(false);
          }}
          closeIcon
          maskClosable={false}
          okText={"Save"}
          onCancel={() => setPurchasePriceModal(false)}
          footer={(_, { OkBtn, CancelBtn }) => (
            <>
              <CancelBtn />
              <OkBtn />
            </>
          )}
        >
          <Divider
            style={{
              borderWidth: "0.2px",
              width: "110%",
              marginLeft: "-24px",
              marginTop: "-4px",
            }}
          />

          <Col span={24} className="mb-10">
            <div className="">
              <Typography className="text-center text-[14px] purchase-label">
                Are you sure you want to hide the
              </Typography>
              <Typography className="text-center ml-2  purchase-label font-semibold text-[14px]">
                purchase price in Invoice .?
              </Typography>
            </div>
          </Col>
        </Modal>

        <CreateItems modalOpen={createItemModal} modalClose={handleClose} />
      </Row>

      <Prompt
        when={!isEmpty(purchaseData) || !isEmpty(totalSectionData)}
        message="Are you sure you want to leave?"
      />
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
    </React.Fragment>
  );
};

export default CreatePurchase;
